import {
  jb_checkbox_css_default
} from "./chunk.IRVICANM.js";
import {
  ae
} from "./chunk.RIMVGMXQ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  FormElement
} from "./chunk.MEO2C6ZS.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-checkbox/jb-checkbox.ts
var JbCheckbox = class extends Initiable(FormElement(r)) {
  constructor() {
    super(...arguments);
    this.checked = false;
  }
  async updated(_changedProperties) {
    if (this.frontendRenderingIdentifier) {
      let storedData = localStorage.getItem("savedFormData");
      if (storedData === null) {
        return;
      }
      storedData = JSON.parse(storedData);
      if (this.frontendRenderingIdentifier && this.frontendRenderingIdentifier in storedData) {
        this.checkbox.checked = storedData[this.frontendRenderingIdentifier] === "true";
      }
    }
    if (_changedProperties.has("label")) {
      await this.updateComplete;
      this._adjustLabelPaddingOnLineBreak();
    }
  }
  appendFormData(formDataEvent) {
    formDataEvent.formData.append(this.name, this.checkbox.checked ? "1" : "");
  }
  async firstUpdated() {
    const resizeObserver = new ResizeObserver(() => {
      this._adjustLabelPaddingOnLineBreak();
    });
    await this.updateComplete;
    const targetElement = this.renderRoot.querySelector("label");
    resizeObserver.observe(targetElement, {});
  }
  isChecked() {
    return !!this.checkbox.checked;
  }
  validate() {
    const valid = this.requiredText ? this.checkbox.checked : true;
    this.showError = !valid;
    return valid;
  }
  _adjustLabelPaddingOnLineBreak() {
    try {
      const singleLineHeight = 20;
      if (this.labelElement && this.labelContent && this.labelContent.offsetHeight > singleLineHeight) {
        this.labelElement.classList.add("multiple-lines");
      } else {
        this.labelElement.classList.remove("multiple-lines");
      }
    } catch (e2) {
    }
  }
  _handleInputChange(e2) {
    this.value = e2.target.value;
    if (this.frontendRenderingIdentifier) {
      let storedData = localStorage.getItem("savedFormData");
      if (storedData !== null) {
        storedData = JSON.parse(storedData);
      } else {
        storedData = {};
      }
      storedData[this.frontendRenderingIdentifier] = this.checkbox.checked.toString();
      localStorage.setItem("savedFormData", JSON.stringify(storedData));
    }
  }
  _handleKeyDown(e2) {
    if (e2.code === "Space" || e2.code === "Enter") {
      e2.target.click();
      e2.preventDefault();
    }
  }
  render() {
    return ke`
      <div
        class=${Rt({
      error: this.showError || !!this.errorText,
      "has-after-checkbox-text": this.afterCheckboxText || !!this.afterCheckboxText,
      "has-before-checkbox-text": this.beforeCheckboxText || !!this.beforeCheckboxText,
      white: !!this.isWhite
    })}
      >
        ${this.beforeCheckboxText ? ae(`
                <p class="before-checkbox-text">
                  ${this.beforeCheckboxText}
                </p> `) : D}
        <label
          tabindex="0"
          @keydown=${this._handleKeyDown}
        >
          <input
            @change=${this._handleInputChange}
            type="checkbox"
            name="${this.name}"
            .value=${typeof this.value === "string" ? this.value : ""}
            ?required=${!!this.requiredText}
            ?disabled=${this.disabled}
            ?checked=${this.checked}
            aria-errormessage=${this.errorText || this.showError ? `${this.name}_error` : D}
            aria-invalid="${this.errorText || this.showError ? "true" : "false"}"
            aria-checked=${this.checked}
          />
          <span>${ae(this.label)}${this.requiredText ? " *" : D}</span>
        </label>
        ${this.afterCheckboxText ? ae(`
              <p class="after-checkbox-text">
                ${this.afterCheckboxText}
              </p>
          `) : D}
        <div
          id="${this.name}_error"
          aria-live="polite"
        >
          ${this.errorText ? ke`
                <p class="error-msg">
                  <span>${this.errorText}</span>
                </p>
              ` : D}
          ${this.showError ? ke`
                <p class="error-msg">
                  <span>${this.requiredText}</span>
                </p>
              ` : D}
        </div>
      </div>
    `;
  }
};
JbCheckbox.styles = jb_checkbox_css_default;
JbCheckbox.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbCheckbox.prototype, "afterCheckboxText", 2);
__decorateClass([
  n()
], JbCheckbox.prototype, "beforeCheckboxText", 2);
__decorateClass([
  e("input")
], JbCheckbox.prototype, "checkbox", 2);
__decorateClass([
  n({ type: Boolean })
], JbCheckbox.prototype, "checked", 2);
__decorateClass([
  n({ type: Boolean })
], JbCheckbox.prototype, "isWhite", 2);
__decorateClass([
  n()
], JbCheckbox.prototype, "label", 2);
__decorateClass([
  e("label span")
], JbCheckbox.prototype, "labelContent", 2);
__decorateClass([
  e("label")
], JbCheckbox.prototype, "labelElement", 2);
JbCheckbox = __decorateClass([
  customElement("jb-checkbox")
], JbCheckbox);

export {
  JbCheckbox
};
